exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#product-link {\n  color: #868e96 !important; }\n\n.no-pdd {\n  padding-left: 0; }\n\n.qty {\n  text-align: end; }\n\n.img {\n  width: 20rem;\n  height: 20rem; }\n\n.result {\n  font-size: 1.25rem;\n  font-weight: 600; }\n\n.label {\n  font-weight: 500; }\n\n.label-value {\n  font-weight: 600; }\n\n.product_MOQ {\n  font-size: 10px;\n  border-radius: 7px;\n  background: #f51905;\n  color: #ffffff;\n  padding-left: 7px;\n  padding-right: 7px;\n  display: inline-block;\n  line-height: 14px; }\n\n.product_NCNR {\n  font-size: 13px;\n  border-radius: 5px;\n  background: #f51905;\n  color: #ffffff;\n  padding-left: 5px;\n  padding-right: 5px;\n  display: inline-block;\n  line-height: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/product-detail/product-detail.component.scss
// module id = ../../../../../src/app/product-detail/product-detail.component.scss
// module chunks = main